import { CognitoUserPool} from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-west-1_PFkfzb3IQ",
    ClientId: "63q4fo9dp9b7nfeudov2qs2ovj"
}

export default new CognitoUserPool(poolData);
